var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tech-form"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('signin-form.tech-undertitle')))]),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.min)+":"+_vm._s(_vm.sec))])])
}
var staticRenderFns = []

export { render, staticRenderFns }